var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import EditableSection from 'components/v2/EditableSection';
import Select from 'components/v2/select';
const Operation = ({ data, onUpdateCarrier, className }) => {
    const { t } = useTranslation();
    const [initialData, setInitialData] = useState({});
    const [operationsData, setOperationsData] = useState({});
    const getInitData = () => {
        if (data) {
            setInitialData(data);
            setOperationsData(data);
        }
    };
    useEffect(() => {
        getInitData();
    }, [data]);
    const onChange = (field, value) => {
        setOperationsData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    const handleSave = async () => {
        const updates = {};
        const changed = __rest(operationsData, []);
        Object.keys(changed).forEach((key) => {
            if (initialData[key] !== changed[key]) {
                updates[key] = changed[key];
            }
        });
        if (Object.keys(updates).length) {
            await onUpdateCarrier(updates);
        }
    };
    const handleAfterSave = (onSaveSuccess) => {
        return (updatedData = {}) => {
            setInitialData((prev) => (Object.assign(Object.assign({}, prev), updatedData)));
            onSaveSuccess();
        };
    };
    return (React.createElement(EditableSection, { title: t('OPERATIONS'), className: classNames(className), canEdit: true }, (editing, saving, onSaveSuccess, onSaveFail) => !editing ? (React.createElement(OperationSummary, { fields: initialData })) : (React.createElement(OperationForm, { fields: operationsData, onChange: onChange, onSaveCarrier: () => handleSave(), saving: saving, onSaveSuccess: handleAfterSave(onSaveSuccess), onSaveFail: onSaveFail }))));
};
const OperationSummary = ({ fields = {} }) => {
    const { t } = useTranslation();
    const { data_entry_agent, carrier_success_manager, account_support_agent } = fields;
    const na = t('NONE');
    return (React.createElement("div", { className: "grid grid-cols-1 gap-4" },
        React.createElement(DescriptionListItem, { label: t('DATA_ENTRY') }, data_entry_agent || na),
        React.createElement(DescriptionListItem, { label: t('CARRIER_SUCCESS_REPRESENTATIVE') }, carrier_success_manager || na),
        React.createElement(DescriptionListItem, { label: t('ACCOUNT_SUPPORT') }, account_support_agent || na)));
};
const OperationForm = ({ fields, onChange, saving, onSaveCarrier, onSaveSuccess, onSaveFail, }) => {
    const { t } = useTranslation();
    const saveForm = async () => {
        try {
            await onSaveCarrier();
            onSaveSuccess(fields);
        }
        catch (e) {
            onSaveFail();
        }
    };
    useEffect(() => {
        if (saving) {
            saveForm();
        }
    }, [saving]);
    const { admins } = fields;
    return (React.createElement("div", { className: "grid gap-4" },
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", selected: fields.data_entry_agent, onSelect: ({ slug }) => onChange('data_entry_agent', slug), info: t('DATA_ENTRY_TIP'), label: t('DATA_ENTRY'), inputClassNames: "lg:w-4/5 w-1/2" }),
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", selected: fields.carrier_success_manager, onSelect: ({ slug }) => onChange('carrier_success_manager', slug), info: t('CARRIER_SUCCESS_REPRESENTATIVE_TIP'), label: t('CARRIER_SUCCESS_REPRESENTATIVE'), inputClassNames: "lg:w-4/5 w-1/2" }),
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", selected: fields.account_support_agent, onSelect: ({ slug }) => onChange('account_support_agent', slug), info: t('ACCOUNT_SUPPORT_TIP'), label: t('ACCOUNT_SUPPORT'), inputClassNames: "lg:w-4/5 w-1/2" })));
};
export default Operation;
